<template>
  <div id="app">
    <!-- 不使用布局的页面 -->
    <router-view v-if="isLoggedIn && $route.meta.noLayout" />
    
    <!-- 使用主布局的页面 -->
    <el-container v-else-if="isLoggedIn" class="main-layout">
      <!-- 侧边栏 -->
      <el-aside
        :width="isMobile ? '100%' : (isCollapse ? '64px' : '220px')"
        class="sidebar"
        :class="{ 'is-collapse': isCollapse, 'is-mobile': isMobile, 'is-mobile-open': isMobile && mobileMenuOpen }"
      >
        <!-- Logo区域 -->
        <div class="logo-section">
          <div class="logo-icon">
            <el-icon size="28"><Monitor /></el-icon>
          </div>
          <div class="logo-text" v-show="!isCollapse">
            <h2>云枢讯维</h2>
            <span class="version">v1.0</span>
          </div>
          <!-- 移动端：顶栏菜单展开/收起 -->
          <div class="mobile-menu-toggle" @click="toggleMobileMenu">
            <el-icon size="20">
              <Close v-if="mobileMenuOpen" />
              <Fold v-else />
            </el-icon>
          </div>
        </div>

        <!-- 菜单 -->
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical"
          :collapse="isMobile ? false : isCollapse"
          :collapse-transition="false"
          @select="handleMenuSelect"
          background-color="transparent"
          text-color="#94a3b8"
          active-text-color="#fff"
        >
          <!-- 仪表板 -->
          <el-menu-item v-if="hasMenu('dashboard')" index="dashboard" class="menu-item">
            <el-icon><Monitor /></el-icon>
            <template #title>
              <span class="menu-title">仪表板</span>
            </template>
          </el-menu-item>

          <!-- 设备管理 -->
          <el-sub-menu v-if="hasMenu('device')" index="asset-menu" class="menu-item">
            <template #title>
              <el-icon><Box /></el-icon>
              <span class="menu-title">设备管理</span>
            </template>
            <el-menu-item v-if="hasMenu('device:list')" index="devices">
              <span class="sub-menu-dot"></span>
              <span>设备资产管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('device:trace')" index="device-trace-list">
              <span class="sub-menu-dot"></span>
              <span>设备资产追溯</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('device:datacenter')" index="datacenter-management">
              <span class="sub-menu-dot"></span>
              <span>机房区域管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('device:3d')" index="datacenter-3d">
              <span class="sub-menu-dot"></span>
              <span>3D可视化</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('device:3d:test')" index="datacenter-3d-test">
              <span class="sub-menu-dot"></span>
              <span>3D可视化测试</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('device:3d:test1')" index="datacenter-3d-test1">
              <span class="sub-menu-dot"></span>
              <span>3D可视化测试1</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('digitaltwin')" index="datacenter-3d-digital-twin">
              <span class="sub-menu-dot"></span>
              <span>数字孪生</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('digitaltwin:datacenter')" index="digital-twin-datacenter">
              <span class="sub-menu-dot"></span>
              <span>数字孪生机房</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('asset')" index="asset-management">
              <span class="sub-menu-dot"></span>
              <span>基础数据管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('device:mount')" index="device-mount-management">
              <span class="sub-menu-dot"></span>
              <span>设备上架管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('asset:rule')" index="mount-number-rules">
              <span class="sub-menu-dot"></span>
              <span>上架编号规则</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('asset:rule')" index="asset-number-rules">
              <span class="sub-menu-dot"></span>
              <span>资产编号规则</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 服务器管理 -->
          <el-sub-menu v-if="hasMenu('server')" index="server-menu" class="menu-item">
            <template #title>
              <el-icon><Cpu /></el-icon>
              <span class="menu-title">服务器管理</span>
            </template>
            <el-menu-item v-if="hasMenu('server:vcenter') || hasMenu('server:vm') || hasMenu('server:rank')" index="server-management">
              <span class="sub-menu-dot"></span>
              <span>服务器列表</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 配线架管理 -->
          <el-sub-menu v-if="hasMenu('patch')" index="patch-panel-menu" class="menu-item">
            <template #title>
              <el-icon><Connection /></el-icon>
              <span class="menu-title">配线架管理</span>
            </template>
            <el-menu-item index="patch-panels">
              <span class="sub-menu-dot"></span>
              <span>配线架列表</span>
            </el-menu-item>
            <el-menu-item index="binding-records">
              <span class="sub-menu-dot"></span>
              <span>端口绑定记录</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 设备组件 -->
          <el-sub-menu v-if="hasMenu('component')" index="device-components-menu" class="menu-item">
            <template #title>
              <el-icon><Grid /></el-icon>
              <span class="menu-title">设备组件</span>
            </template>
            <el-menu-item index="component-types">
              <span class="sub-menu-dot"></span>
              <span>组件类型管理</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- IPAM管理 -->
          <el-sub-menu v-if="hasMenu('network:ipam')" index="ipam-menu" class="menu-item">
            <template #title>
              <el-icon><MapLocation /></el-icon>
              <span class="menu-title">IPAM管理</span>
            </template>
            <el-menu-item v-if="hasMenu('network:ipam:vlan')" index="ipam-vlans">
              <span class="sub-menu-dot"></span>
              <span>VLAN管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('network:ipam:ip')" index="ipam-pools">
              <span class="sub-menu-dot"></span>
              <span>IP地址池管理</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 网络设备 -->
          <el-menu-item v-if="hasMenu('network')" index="network-devices" class="menu-item">
            <el-icon><Switch /></el-icon>
            <template #title>
              <span class="menu-title">网络设备</span>
            </template>
          </el-menu-item>

          <!-- 网络拓扑 -->
          <el-menu-item v-if="hasMenu('network:topology')" index="network-topology" class="menu-item">
            <el-icon><Share /></el-icon>
            <template #title>
              <span class="menu-title">网络拓扑</span>
            </template>
          </el-menu-item>

          <el-menu-item v-if="hasMenu('network:topology:2')" index="network-topology-g6" class="menu-item">
            <el-icon><Share /></el-icon>
            <template #title>
              <span class="menu-title">网络拓扑2 (G6)</span>
            </template>
          </el-menu-item>

          <el-menu-item v-if="hasMenu('network:topology:3')" index="network-topology-3" class="menu-item">
            <el-icon><Share /></el-icon>
            <template #title>
              <span class="menu-title">网络拓扑3</span>
            </template>
          </el-menu-item>

          <!-- 监控管理 -->
          <el-menu-item v-if="hasMenu('monitoring')" index="monitoring-template" class="menu-item">
            <el-icon><DataAnalysis /></el-icon>
            <template #title>
              <span class="menu-title">监控管理</span>
            </template>
          </el-menu-item>

          <!-- 日志服务器 -->
          <el-menu-item v-if="hasMenu('logserver')" index="log-server" class="menu-item">
            <el-icon><Document /></el-icon>
            <template #title>
              <span class="menu-title">日志服务器</span>
            </template>
          </el-menu-item>

          <!-- 告警管理 -->
          <el-sub-menu v-if="hasMenu('monitoring:alert')" index="alert-menu" class="menu-item">
            <template #title>
              <el-icon><Bell /></el-icon>
              <span class="menu-title">告警管理</span>
            </template>
            <el-menu-item v-if="hasMenu('monitoring:alert')" index="alerts">
              <span class="sub-menu-dot"></span>
              <span>告警列表</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('notification:config')" index="notification-config">
              <span class="sub-menu-dot"></span>
              <span>通知配置</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('notification:recovery-events')" index="recovery-events">
              <span class="sub-menu-dot"></span>
              <span>恢复事件</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('notification:template')" index="notification-templates">
              <span class="sub-menu-dot"></span>
              <span>通知模板</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- SNMP管理 -->
          <el-sub-menu v-if="hasMenu('snmp')" index="snmp-menu" class="menu-item">
            <template #title>
              <el-icon><Connection /></el-icon>
              <span class="menu-title">SNMP管理</span>
            </template>
            <el-menu-item v-if="hasMenu('snmp:config')" index="snmp">
              <span class="sub-menu-dot"></span>
              <span>SNMP配置</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('snmp:walk')" index="snmp-walk">
              <span class="sub-menu-dot"></span>
              <span>SNMP WALK</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('snmp:mib')" index="mib-files">
              <span class="sub-menu-dot"></span>
              <span>MIB文件管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('snmp:mib')" index="mibs">
              <span class="sub-menu-dot"></span>
              <span>MIB库</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('snmp:oid')" index="oid-templates">
              <span class="sub-menu-dot"></span>
              <span>OID模板</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('snmp:oid')" index="oid-template-groups">
              <span class="sub-menu-dot"></span>
              <span>OID模板组</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 远程管理 -->
          <el-menu-item v-if="hasMenu('remote')" index="remote" class="menu-item">
            <el-icon><Link /></el-icon>
            <template #title>
              <span class="menu-title">远程管理</span>
            </template>
          </el-menu-item>

          <!-- 自动发现 -->
          <el-menu-item v-if="hasMenu('discovery')" index="discovery" class="menu-item">
            <el-icon><Search /></el-icon>
            <template #title>
              <span class="menu-title">自动发现</span>
            </template>
          </el-menu-item>

          <!-- 定时任务 -->
          <el-menu-item v-if="hasMenu('scheduled')" index="scheduled-tasks" class="menu-item">
            <el-icon><Timer /></el-icon>
            <template #title>
              <span class="menu-title">定时任务</span>
            </template>
          </el-menu-item>

          <!-- AI助手 -->
          <el-sub-menu v-if="hasMenu('ai')" index="ai-menu" class="menu-item">
            <template #title>
              <el-icon><MagicStick /></el-icon>
              <span class="menu-title">AI助手</span>
            </template>
            <el-menu-item v-if="hasMenu('ai:chat')" index="ai-chat">
              <span class="sub-menu-dot"></span>
              <span>AI对话</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('ai:platform')" index="ai-platforms">
              <span class="sub-menu-dot"></span>
              <span>平台配置</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('ai:workflow')" index="ai-workflow">
              <span class="sub-menu-dot"></span>
              <span>AI工作流设计器</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 工作流 -->
          <el-sub-menu v-if="hasMenu('workflow')" index="workflow-menu" class="menu-item">
            <template #title>
              <el-icon><Connection /></el-icon>
              <span class="menu-title">工作流</span>
            </template>
            <el-menu-item v-if="hasMenu('workflow:center')" index="workflow-process-center">
              <el-icon><Connection /></el-icon>
              <span>流程中心</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('workflow:manage')" index="workflow-process-management">
              <span class="sub-menu-dot"></span>
              <span>流程管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('workflow:manage')" index="workflow-monitoring">
              <span class="sub-menu-dot"></span>
              <span>流程监控</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 业务模块（流程发布的动态菜单） -->
          <el-sub-menu
            v-for="mod in businessModules"
            :key="mod.module_key"
            v-show="hasMenu(mod.permission_prefix)"
            :index="`biz-${mod.module_key}`"
            class="menu-item"
          >
            <template #title>
              <el-icon><Document /></el-icon>
              <span class="menu-title">{{ mod.module_name }}</span>
            </template>
            <el-menu-item
              v-if="hasMenu(`${mod.permission_prefix}:apply`)"
              :index="`/biz/${mod.module_key}/apply`"
            >
              <span class="sub-menu-dot"></span>
              <span>{{ mod.module_name }}申请</span>
            </el-menu-item>
            <el-menu-item
              v-if="hasMenu(`${mod.permission_prefix}:list`)"
              :index="`/biz/${mod.module_key}/list`"
            >
              <span class="sub-menu-dot"></span>
              <span>{{ mod.module_name }}列表</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 运维办公 -->
          <el-sub-menu v-if="hasMenu('office')" index="office-menu" class="menu-item">
            <template #title>
              <el-icon><OfficeBuilding /></el-icon>
              <span class="menu-title">运维办公</span>
            </template>
            <el-menu-item v-if="hasMenu('office:worklog')" index="work-logs">
              <el-icon><Notebook /></el-icon>
              <span>工作日志</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('office:plan')" index="work-plans">
              <span class="sub-menu-dot"></span>
              <span>工作计划</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('office:todo')" index="work-todos">
              <span class="sub-menu-dot"></span>
              <span>待办清单</span>
            </el-menu-item>
          </el-sub-menu>

          <!-- 系统管理 -->
          <el-sub-menu v-if="hasMenu('system')" index="system-menu" class="menu-item">
            <template #title>
              <el-icon><Setting /></el-icon>
              <span class="menu-title">系统管理</span>
            </template>
            <el-menu-item v-if="hasMenu('system:user')" index="system-users">
              <span class="sub-menu-dot"></span>
              <span>用户管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('system:role')" index="system-roles">
              <span class="sub-menu-dot"></span>
              <span>角色管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('system:permission')" index="system-permissions">
              <span class="sub-menu-dot"></span>
              <span>权限管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('system:dept')" index="system-departments">
              <span class="sub-menu-dot"></span>
              <span>部门管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('system:position')" index="system-positions">
              <span class="sub-menu-dot"></span>
              <span>岗位管理</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('system:dict')" index="system-dicts">
              <span class="sub-menu-dot"></span>
              <span>字典管理</span>
            </el-menu-item>
            <el-menu-item index="network-device-sync">
              <span class="sub-menu-dot"></span>
              <span>设备类型同步配置</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('system:log:login')" index="system-login-logs">
              <span class="sub-menu-dot"></span>
              <span>登录日志</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('system:log:operation')" index="system-operation-logs">
              <span class="sub-menu-dot"></span>
              <span>操作日志</span>
            </el-menu-item>
            <el-menu-item index="system-time-sync">
              <span class="sub-menu-dot"></span>
              <span>时间同步</span>
            </el-menu-item>
            <el-menu-item v-if="hasMenu('system:setting')" index="system-settings">
              <span class="sub-menu-dot"></span>
              <span>系统设置</span>
            </el-menu-item>
            <!-- 开放接口令牌管理仅超级管理员可见，后端同样只放行超级管理员 -->
            <el-menu-item v-if="currentUser?.is_superuser" index="system-open-api">
              <span class="sub-menu-dot"></span>
              <span>开放接口</span>
            </el-menu-item>
          </el-sub-menu>
        </el-menu>

        <!-- 展开/收起按钮 -->
        <div class="collapse-btn" @click="toggleCollapse">
          <el-icon size="18">
            <Fold v-if="!isCollapse" />
            <Expand v-else />
          </el-icon>
        </div>
      </el-aside>

      <!-- 主内容区 -->
      <el-container class="content-wrapper" :class="{ 'workflow-content': isWorkflowPage }">
        <!-- 顶部导航栏 -->
        <el-header class="header">
          <div class="header-left">
            <!-- 面包屑导航 -->
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>{{ currentPageTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="header-right">
            <!-- 搜索框 -->
            <div class="header-search">
              <el-icon><Search /></el-icon>
              <input type="text" placeholder="全局搜索..." />
              <span class="shortcut">⌘K</span>
            </div>

            <!-- 通知：显示未恢复的告警数，点击进入告警列表 -->
            <el-badge
              :value="activeAlertCount"
              :max="99"
              :hidden="activeAlertCount === 0"
              class="header-icon-btn"
              title="查看未恢复告警"
              @click="goToAlerts"
            >
              <el-icon size="20"><Bell /></el-icon>
            </el-badge>

            <!-- 全屏 -->
            <div class="header-icon-btn" @click="toggleFullscreen">
              <el-icon size="20"><FullScreen /></el-icon>
            </div>

            <!-- 主题切换 -->
            <div class="header-icon-btn" @click="toggleTheme">
              <el-icon size="20"><Sunny v-if="isDark" /><Moon v-else /></el-icon>
            </div>

            <!-- 用户菜单 -->
            <el-dropdown @command="handleCommand" class="user-dropdown">
              <div class="user-info">
                <div class="user-avatar">
                  <el-avatar 
                    :size="36" 
                    :src="currentUser?.avatar || defaultAvatar"
                    class="header-avatar"
                  >
                    <el-icon size="20"><UserFilled /></el-icon>
                  </el-avatar>
                </div>
                <div class="user-detail" v-show="!isCollapse">
                  <span class="user-name">{{ currentUser?.real_name || currentUser?.username || '用户' }}</span>
                  <span class="user-role">{{ currentUser?.is_superuser ? '超级管理员' : '普通用户' }}</span>
                </div>
                <el-icon class="dropdown-arrow"><ArrowDown /></el-icon>
              </div>
              <template #dropdown>
                <el-dropdown-menu class="user-dropdown-menu">
                  <el-dropdown-item command="profile">
                    <el-icon><User /></el-icon>
                    <span>个人中心</span>
                  </el-dropdown-item>
                  <el-dropdown-item divided command="logout">
                    <el-icon><SwitchButton /></el-icon>
                    <span>退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>

        <!-- 页面标签 -->
        <div class="tabs-bar">
          <div class="tabs-wrapper">
            <div
              v-for="tab in visitedTabs"
              :key="tab.path"
              class="tab-item"
              :class="{ active: activeMenu === tab.name }"
              @click="handleTabClick(tab)"
            >
              <span class="tab-dot" :class="tab.name"></span>
              <span class="tab-title">{{ tab.title }}</span>
              <el-icon class="tab-close" @click.stop="closeTab(tab)"><Close /></el-icon>
            </div>
          </div>
        </div>

        <!-- 主内容 -->
        <el-main class="main-content">
          <router-view v-slot="{ Component }">
            <transition v-if="!$route.meta.noTransition" name="fade-transform" mode="out-in">
              <component :is="Component" />
            </transition>
            <component v-else :is="Component" />
          </router-view>
        </el-main>
      </el-container>
    </el-container>

    <!-- 登录页 -->
    <router-view v-else />
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import {
  Monitor, Box, TrendCharts, Bell, Connection, FolderOpened,
  PieChart, Link, Search, Timer, MagicStick, OfficeBuilding,
  Setting, Fold, Expand, FullScreen, Sunny, Moon, UserFilled,
  ArrowDown, User, SwitchButton, Close, DataAnalysis, Grid,
  MapLocation, Switch, Share, Cpu, Document, Notebook
} from '@element-plus/icons-vue'
import { workflowApi } from '@/services/workflowApi'
import { alertsAPI } from '@/services/api'
import { applyTheme, isDarkTheme } from '@/utils/theme'

export default {
  name: 'App',
  components: {
    Monitor, Box, TrendCharts, Bell, Connection, FolderOpened,
    PieChart, Link, Search, Timer, MagicStick, OfficeBuilding,
    Setting, Fold, Expand, FullScreen, Sunny, Moon, UserFilled,
    ArrowDown, User, SwitchButton, Close, DataAnalysis, Grid,
    MapLocation, Switch, Share, Cpu, Document, Notebook
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    // 默认头像
    const defaultAvatar = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'

    const activeMenu = ref('dashboard')
    const isCollapse = ref(false)

    // 移动端（窄屏）把左侧菜单折叠到顶部：默认收起，点顶栏按钮展开
    const mobileMedia = window.matchMedia('(max-width: 768px)')
    const isMobile = ref(mobileMedia.matches)
    const mobileMenuOpen = ref(false)
    const handleViewportChange = (event) => {
      isMobile.value = event.matches
      // 回到宽屏时收起移动端下拉，避免状态残留
      if (!event.matches) mobileMenuOpen.value = false
    }
    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
    }
    // 主题：与 main.js 提前写入的状态保持一致，刷新后不会闪回浅色
    const isDark = ref(isDarkTheme())
    const visitedTabs = ref([
      { name: 'dashboard', title: '仪表盘', path: '/dashboard' }
    ])

    const isLoggedIn = computed(() => store.state.isLoggedIn)
    const currentUser = computed(() => store.state.user)

    // 业务模块（流程一键发布的动态菜单）
    const businessModules = ref([])
    const loadBusinessModules = async () => {
      try {
        const res = await workflowApi.getBusinessModules()
        const items = res?.data?.items || []
        businessModules.value = items.filter(m => m.status === 'active')
      } catch (error) {
        console.warn('加载业务模块失败:', error)
        businessModules.value = []
      }
    }

    // 是否工作流页面
    const isWorkflowPage = computed(() => route?.path?.startsWith('/workflow') || false)

    // 当前页面标题
    const currentPageTitle = computed(() => {
      return routeTitles[route.name] || route.name || '未知页面'
    })

    // 路由标题映射
    const routeTitles = {
      'dashboard': '仪表盘',
      'devices': '设备资产管理',
      'datacenter-management': '机房区域管理',
      'datacenter-3d': '3D可视化',
      'datacenter-3d-test': '3D可视化测试',
      'datacenter-3d-test1': '3D可视化测试1',
      'asset-management': '基础数据管理',
      'device-mount-management': '设备上架管理',
      'mount-number-rules': '上架编号规则',
      'asset-number-rules': '资产编号规则',
      'monitoring': '监控管理',
      'graphs': '图形管理',
      'alerts': '告警列表',
      'notification-config': '通知配置管理',
      'recovery-events': '恢复事件记录',
      'snmp': 'SNMP配置',
      'snmp-walk': 'SNMP WALK',
      'mib-files': 'MIB文件管理',
      'mibs': 'MIB库',
      'oid-templates': 'OID模板',
      'oid-template-groups': 'OID模板组',
      'remote': '远程管理',
      'discovery': '自动发现',
      'scheduled-tasks': '定时任务',
      'ai-chat': 'AI对话',
      'ai-platforms': '平台配置',
      'ai-workflow': 'AI工作流设计器',
      'system-settings': '系统管理',
      'system-open-api': '开放接口',
      'workflow-process-templates': '流程模板中心',
      'component-types': '组件类型管理',
      'ipam-vlans': 'VLAN管理',
      'ipam-pools': 'IP地址池管理',
      'network-devices': '网络设备列表',
      'network-topology': '网络拓扑',
      'network-topology-g6': '网络拓扑2 (G6)',
      'network-topology-3': '网络拓扑3',
      'datacenter-3d-digital-twin': '数字孪生',
      'digital-twin-datacenter': '数字孪生机房',
      'network-device-sync': '设备类型同步配置',
      'work-logs': '工作日志',
      'work-plans': '工作计划',
      'work-todos': '待办清单',
      'server-management': '服务器管理',
      'patch-panels': '配线架管理',
      'patch-panel-detail': '配线架详情',
      'binding-records': '端口绑定记录',
      'log-server': '日志服务器'
    }

    watch(() => route.name, (newRouteName) => {
      if (newRouteName) {
        // 业务模块路由使用路径作为菜单 index，保证高亮正确
        if (newRouteName === 'biz-apply' || newRouteName === 'biz-list') {
          activeMenu.value = route.path
          return
        }
        activeMenu.value = newRouteName
        // 添加标签页
        const title = routeTitles[newRouteName] || newRouteName
        const existingTab = visitedTabs.value.find(t => t.name === newRouteName)
        if (!existingTab) {
          visitedTabs.value.push({
            name: newRouteName,
            title: title,
            path: route.path
          })
        }
      }
    }, { immediate: true })

    const toggleCollapse = () => {
      isCollapse.value = !isCollapse.value
    }

    const toggleFullscreen = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
    }

    const toggleTheme = () => {
      isDark.value = applyTheme(isDark.value ? 'light' : 'dark')
    }

    const handleMenuSelect = (index) => {
      // 移动端顶栏菜单：选完一项就收起，避免一直遮住内容
      mobileMenuOpen.value = false
      if (index && index.startsWith && index.startsWith('/')) {
        router.push(index)
      } else {
        router.push({ name: index })
      }
    }

    const handleTabClick = (tab) => {
      router.push(tab.path)
    }

    const closeTab = (tab) => {
      const index = visitedTabs.value.findIndex(t => t.name === tab.name)
      if (index > -1) {
        visitedTabs.value.splice(index, 1)
        // 如果关闭的是当前标签，切换到上一个标签
        if (activeMenu.value === tab.name && visitedTabs.value.length > 0) {
          const prevTab = visitedTabs.value[Math.max(0, index - 1)]
          router.push(prevTab.path)
        }
      }
    }

    const handleCommand = async (command) => {
      if (command === 'logout') {
        // 调用 store 的 logout action 清除所有认证信息
        await store.dispatch('logout')
        router.push('/login')
      } else if (command === 'profile') {
        router.push('/profile')
      }
    }

    // 检查是否有菜单权限
    const hasMenu = (menuCode) => {
      // 超级管理员拥有所有权限
      if (currentUser.value?.is_superuser) return true
      // 检查用户菜单列表
      const menus = store.state.menus || []
      // menus 是对象数组，检查 code 或 permission_code 字段
      return menus.some(menu => menu.code === menuCode || menu.permission_code === menuCode)
    }

    // 顶部铃铛：显示未恢复（active）的告警数，每 60 秒刷新一次
    const activeAlertCount = ref(0)
    let alertTimer = null

    const fetchActiveAlertCount = async () => {
      try {
        const res = await alertsAPI.getAlertsPaginated({
          status: 'active', page: 1, page_size: 1
        })
        activeAlertCount.value = res?.data?.total ?? 0
      } catch (error) {
        // 静默处理：未登录或接口异常时不要把铃铛变成报错来源
      }
    }

    const goToAlerts = () => {
      router.push('/alerts')
    }

    // 页面加载时重新获取用户信息（解决刷新后菜单丢失问题）
    onMounted(async () => {
      if (store.state.isLoggedIn && store.state.user?.id) {
        try {
          // 重新获取用户信息，包括菜单权限
          const result = await store.dispatch('getUserInfo')
          if (!result.success) {
            console.warn('重新获取用户信息失败:', result.message)
          }
        } catch (error) {
          console.error('重新获取用户信息出错:', error)
        }
        // 加载已发布的业务模块菜单
        loadBusinessModules()
      }
      if (store.state.isLoggedIn) {
        fetchActiveAlertCount()
        alertTimer = setInterval(fetchActiveAlertCount, 60000)
      }
      mobileMedia.addEventListener('change', handleViewportChange)
    })

    onUnmounted(() => {
      if (alertTimer) {
        clearInterval(alertTimer)
        alertTimer = null
      }
      mobileMedia.removeEventListener('change', handleViewportChange)
    })

    return {
      activeMenu,
      isCollapse,
      isMobile,
      mobileMenuOpen,
      toggleMobileMenu,
      isDark,
      isLoggedIn,
      isWorkflowPage,
      currentUser,
      defaultAvatar,
      visitedTabs,
      currentPageTitle,
      toggleCollapse,
      toggleFullscreen,
      toggleTheme,
      handleMenuSelect,
      handleTabClick,
      closeTab,
      handleCommand,
      hasMenu,
      businessModules,
      loadBusinessModules,
      activeAlertCount,
      goToAlerts
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Inter', 'Helvetica Neue', Helvetica, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}

/* 主布局 */
.main-layout {
  height: 100vh;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
}

/* 侧边栏 */
.sidebar {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

/* Logo区域 */
.logo-section {
  height: 70px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.logo-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.logo-text {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.logo-text h2 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  white-space: nowrap;
}

.logo-text .version {
  font-size: 11px;
  color: #667eea;
  font-weight: 600;
}

/* 菜单样式 */
.el-menu-vertical {
  flex: 1;
  border-right: none;
  padding: 12px 8px;
}

.menu-item {
  margin-bottom: 4px;
}

.menu-item :deep(.el-icon) {
  font-size: 20px;
  color: #94a3b8;
}

.menu-item.is-active :deep(.el-icon) {
  color: #667eea;
}

.menu-title {
  font-size: 14px;
  font-weight: 500;
}

.el-menu-item {
  height: 48px;
  line-height: 48px;
  border-radius: 10px;
  margin: 0 4px;
  transition: all 0.3s ease;
}

.el-menu-item:hover {
  background: rgba(102, 126, 234, 0.1) !important;
}

.el-menu-item.is-active {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%) !important;
  border: 1px solid rgba(102, 126, 234, 0.3);
}

/* 子菜单样式 */
.el-sub-menu :deep(.el-sub-menu__title) {
  height: 48px;
  line-height: 48px;
  border-radius: 10px;
  margin: 0 4px;
  transition: all 0.3s ease;
}

.el-sub-menu :deep(.el-sub-menu__title:hover) {
  background: rgba(102, 126, 234, 0.1) !important;
}

.el-sub-menu.is-active :deep(.el-sub-menu__title) {
  color: #667eea !important;
}

.sub-menu-dot {
  width: 6px;
  height: 6px;
  background: #64748b;
  border-radius: 50%;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.sub-sub-menu-dot {
  width: 4px;
  height: 4px;
  background: #94a3b8;
  border-radius: 50%;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.el-menu-item:hover .sub-menu-dot,
.el-menu-item:hover .sub-sub-menu-dot,
.el-menu-item.is-active .sub-menu-dot,
.el-menu-item.is-active .sub-sub-menu-dot {
  background: #667eea;
  box-shadow: 0 0 8px rgba(102, 126, 234, 0.5);
}

/* 展开/收起按钮 */
.collapse-btn {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;
  color: #94a3b8;
  transition: all 0.3s ease;
}

.collapse-btn:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
}

/* 内容包装器 */
.content-wrapper {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  display: flex;
  flex-direction: column;
}

/* 工作流页面内容包装器：使用浅色背景以匹配钉钉风格 */
.content-wrapper.workflow-content,
.content-wrapper.workflow-content .main-content {
  background: #f2f3f5;
}

/* 顶部导航栏 */
.header {
  height: 70px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.header-left {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 搜索框 */
.header-search {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: #f1f5f9;
  border-radius: 10px;
  width: 280px;
  transition: all 0.3s ease;
}

.header-search:hover {
  background: #e2e8f0;
}

.header-search .el-icon {
  color: #94a3b8;
  font-size: 16px;
}

.header-search input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: #334155;
  flex: 1;
}

.header-search input::placeholder {
  color: #94a3b8;
}

.header-search .shortcut {
  font-size: 11px;
  color: #94a3b8;
  background: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

/* 头部图标按钮 */
.header-icon-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  color: #64748b;
  transition: all 0.3s ease;
}

.header-icon-btn:hover {
  background: #f1f5f9;
  color: #667eea;
}

/* 用户下拉菜单 */
.user-dropdown {
  margin-left: 8px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px 6px 6px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.user-info:hover {
  background: #f1f5f9;
}

.user-avatar {
  width: 38px;
  height: 38px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  overflow: hidden;
}

.header-avatar {
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.user-detail {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.user-role {
  font-size: 12px;
  color: #94a3b8;
}

.dropdown-arrow {
  color: #94a3b8;
  font-size: 12px;
}

/* 用户下拉菜单样式 */
.user-dropdown-menu {
  padding: 8px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.user-dropdown-menu .el-dropdown-menu__item {
  padding: 10px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.user-dropdown-menu .el-dropdown-menu__item:hover {
  background: #f1f5f9;
  color: #667eea;
}

/* 标签栏 */
.tabs-bar {
  height: 44px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 24px;
  display: flex;
  align-items: center;
}

.tabs-wrapper {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
}

.tabs-wrapper::-webkit-scrollbar {
  display: none;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #f1f5f9;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #64748b;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.tab-item:hover {
  background: #e2e8f0;
}

.tab-item.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.tab-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #94a3b8;
}

.tab-item.active .tab-dot {
  background: #fff;
}

.tab-dot.dashboard { background: #10b981; }
.tab-dot.devices { background: #3b82f6; }
.tab-dot.datacenter-management { background: #8b5cf6; }
.tab-dot.alerts { background: #ef4444; }

.tab-close {
  font-size: 12px;
  opacity: 0;
  transition: all 0.3s ease;
}

.tab-item:hover .tab-close {
  opacity: 1;
}

.tab-close:hover {
  color: #ef4444;
}

/* 主内容区 */
.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

/* 页面切换动画 */
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s ease;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* 折叠状态下的样式 */
.sidebar.is-collapse .logo-section {
  justify-content: center;
  padding: 0;
}

.sidebar.is-collapse .collapse-btn {
  justify-content: center;
}

/* 移动端顶部菜单开关：仅窄屏显示，宽屏用侧边栏底部的折叠按钮 */
.mobile-menu-toggle {
  display: none;
  margin-left: auto;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #94a3b8;
  cursor: pointer;
  flex-shrink: 0;
}

.mobile-menu-toggle:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

/* 响应式 */
@media (max-width: 1200px) {
  .header-search {
    width: 200px;
  }
}

@media (max-width: 768px) {
  /* 窄屏：左侧菜单改为顶部可折叠菜单，避免侧边栏挤占手机屏幕 */
  /* 选择器带上 .el-container 以提高优先级，覆盖 Element Plus 默认的横排布局 */
  .el-container.main-layout {
    flex-direction: column;
  }

  .sidebar {
    position: static;
    width: 100%;
    height: auto;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  .logo-section {
    height: 56px;
    padding: 0 12px;
  }

  .logo-icon {
    width: 36px;
    height: 36px;
  }

  .logo-text h2 {
    font-size: 16px;
  }

  .mobile-menu-toggle {
    display: flex;
  }

  /* 菜单默认收起，展开后从顶栏下方下拉，菜单过长时可滚动 */
  .sidebar .el-menu-vertical {
    display: none;
  }

  .sidebar.is-mobile-open .el-menu-vertical {
    display: block;
    max-height: 60vh;
    overflow-y: auto;
    padding: 8px;
  }

  /* 窄屏不显示侧边栏底部的折叠按钮，改用顶栏开关 */
  .sidebar .collapse-btn {
    display: none;
  }

  .header-search {
    display: none;
  }
}

/* ================= 暗色模式适配 =================
   `dark` 类由右上角主题按钮切换（见 utils/theme.js）。
   这里的颜色全部取自 element-plus 的 dark/css-vars.css 变量，
   这样外壳和 Element Plus 组件（卡片、表格、弹窗、下拉）配色一致。
   侧边栏本身已是深色，无需适配。
*/
html.dark,
html.dark body {
  background: var(--el-bg-color-page);
}

html.dark .content-wrapper,
html.dark .main-content {
  background: var(--el-bg-color-page);
}

/* 工作流页面原本用 #f2f3f5 浅色，暗色下同样跟随页面底色 */
html.dark .content-wrapper.workflow-content,
html.dark .content-wrapper.workflow-content .main-content {
  background: var(--el-bg-color-page);
}

html.dark .header,
html.dark .tabs-bar {
  background: var(--el-bg-color);
  border-bottom-color: var(--el-border-color);
}

html.dark .header-search {
  background: var(--el-fill-color);
}

html.dark .header-search:hover {
  background: var(--el-fill-color-dark);
}

html.dark .header-search input {
  color: var(--el-text-color-primary);
}

html.dark .header-search .shortcut {
  background: var(--el-bg-color-overlay);
  border-color: var(--el-border-color);
}

html.dark .header-icon-btn {
  color: var(--el-text-color-regular);
}

html.dark .header-icon-btn:hover {
  background: var(--el-fill-color);
  color: var(--el-color-primary);
}

html.dark .user-info:hover {
  background: var(--el-fill-color);
}

html.dark .user-name {
  color: var(--el-text-color-primary);
}

html.dark .tab-item {
  background: var(--el-fill-color);
  color: var(--el-text-color-regular);
}

html.dark .tab-item:hover {
  background: var(--el-fill-color-dark);
}
</style>
